import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthserviceService {

  constructor() { }

  private userId;

  private userToken;

  private username;

  private userrole;

  private endUserRole;

  private barierToken;

  private email;

  private rights;

  private profileImage;

  private currentlocationId;

  private meetingRoomLicense

  private deskLicense

  private parkingSeatLicense

  private kioskLicense

  private viewPointLicense

  private displayLicense

  private carLicense

  private dashboardKey

  private spaceLicense

  private currentBuildingId

  private currentFloorId;

  public setBarierToken(value) {

    localStorage.setItem('token', value);

  }
  public getBarierToken() {
    // return this.userToken;
    return localStorage.getItem('token')
  }

  public getCurrentlocationId() {
    // return this.currentlocationId;
    // console.log("De",atob(localStorage.getItem('currentlocationId')));

    return localStorage.getItem('currentlocationId')
  }

  public setCurrentlocationId(currentlocationId) {
    //this.currentlocationId = currentlocationId;
    localStorage.setItem('currentlocationId', currentlocationId);
  }

  public getUserId() {
    // return this.userId;
    return atob(localStorage.getItem('userId'));
  }

  public setUserId(userId) {
    //this.userId = userId;
    localStorage.setItem('userId', userId);
  }

  public getUserrole() {
    // return this.userrole;
    return atob(localStorage.getItem('userrole'))
  }

  public setUserrole(userrole) {
    // this.userrole = userrole;
    localStorage.setItem('userrole', userrole);
  }

  public getUsername() {
    // return this.username;
    return localStorage.getItem('username');
  }

  public setUsername(username) {
    //this.username = username;
    localStorage.setItem('username', username);
  }

  public getEmail() {
    // return this.email;
    return atob(localStorage.getItem('email'))
  }

  public setEmail(email) {
    // this.email = email;
    localStorage.setItem('email', email);
  }

  public getRights() {
    // return this.rights;
    return localStorage.getItem('rights');
  }

  public setRights(rights) {
    // this.rights = rights;
    localStorage.setItem('rights', rights);
  }

  public getProfileImage() {
    // return this.profileImage;
    return localStorage.getItem('profileImage');
  }

  public setProfileImage(profileImage) {
    this.profileImage = profileImage;
    localStorage.setItem('profileImage', profileImage);
  }

  public setEndUserRole(endUserRole) {
    localStorage.setItem('endUserRole', endUserRole);
  }

  public getEndUserRole() {
    if ('endUserRole') {
      return atob(localStorage.getItem('endUserRole'))
    }

  }

  public setMeetingRoomLicense(meetingRoomLicense) {
    localStorage.setItem('meetingRoomLicense', meetingRoomLicense);
  }

  public getMeetingRoomLicense() {
    if ('meetingRoomLicense') {
      return atob(localStorage.getItem('meetingRoomLicense'))
    }
  }

  public setDeskLicense(deskLicense) {
    localStorage.setItem('deskLicense', deskLicense);
  }

  public getDeskLicense() {
    if ('deskLicense') {
      return atob(localStorage.getItem('deskLicense'))
    }
  }

  public setSpaceLicense(spaceLicense){
    localStorage.setItem('spaceLicense',spaceLicense);
  }
  public getSpaceLicense() {
    if ('spaceLicense') {
      return atob(localStorage.getItem('spaceLicense'))
    }
  }

  public setParkingSeatLicense(parkingSeatLicense) {
    localStorage.setItem('parkingSeatLicense', parkingSeatLicense);
  }

  public getParkingSeatLicense() {
    if ('parkingSeatLicense') {
      return atob(localStorage.getItem('parkingSeatLicense'))
    }
  }

  public setKioskLicense(kioskLicense) {
    localStorage.setItem('kioskLicense', kioskLicense);
  }

  public getKioskLicense() {
    if ('kioskLicense') {
      return atob(localStorage.getItem('kioskLicense'))
    }
  }

  public setViewPointLicense(viewPointLicense) {
    localStorage.setItem('viewPointLicense', viewPointLicense);
  }

  public getViewPointLicense() {
    if ('viewPointLicense') {
      return atob(localStorage.getItem('viewPointLicense'))
    }
  }

  public setDisplayLicense(displayLicense) {
    localStorage.setItem('displayLicense', displayLicense);
  }

  public getDisplayLicense() {
    if ('displayLicense') {
      return atob(localStorage.getItem('displayLicense'))
    }
  }

  public setCarLicense(carLicense) {
    localStorage.setItem('carLicense', carLicense);
  }

  public getCarLicense() {
    if ('carLicense') {
      return atob(localStorage.getItem('carLicense'))
    }
  }

  public getDashboardKey() {
    if ('dashboardKey') {
      return atob(localStorage.getItem('dashboardKey'))
    }
  }

  public setDashboardKey(dashboardKey) {
    localStorage.setItem('dashboardKey', dashboardKey);
  }

  public setChargingCarLicense(chargingCarLicense) {
    localStorage.setItem('chargingCarLicense', chargingCarLicense);
  }

  public getChargingCarLicense() {
    if ('chargingCarLicense') {
      return atob(localStorage.getItem('chargingCarLicense'))
    }
  }

  public setVisitLicense(visitLicense) {
    localStorage.setItem('visitLicense', visitLicense);
  }

  public getVisitLicense() {
    if ('visitLicense') {
      return atob(localStorage.getItem('visitLicense'))
    }
  }
  public getCurrentBuildingId() {
    return localStorage.getItem('currentBuildingId')
  }

  public setCurrentBuildingId(currentBuildingId) {
    localStorage.setItem('currentBuildingId', currentBuildingId);
  }

  public getCurrentFloorId() {
    return localStorage.getItem('currentFloorId')
  }

  public setCurrentFloorId(currentFloorId) {
    localStorage.setItem('currentFloorId', currentFloorId);
  }

}
